/* eslint-disable import/no-anonymous-default-export */
export default (locationDefault = [], action) => {
  switch (action.type) {
    case "LOCATION_DEFAULT_STOCK_HISTORY":
      return action.payload;

    default:
      return locationDefault;
  }
};
